module.exports = function getResource(label, vars = []) {
    let resources = {
        selectProduct: ':FR:Select your current product for'
    };

    return resources[label];
};
